module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/add/index.js